<template>

  <div class="hit-container">

      <select v-model="board" class="hit-form-control">
        <option v-for="(board, index) in get_boards()" v-if="board.name" v-bind:value="index">{{ $tc("message.board", 1) }}: {{ board.name }}</option>
      </select>

        <ul class="hit-nav hit-nav-tabs">

          <li v-for="i in [1,2,3,4,5]" role="presentation" class="hit-html-li" v-bind:class="check_class(i)" >
            <a href="#" v-on:click.prevent="change_edit(i)" :title="$t('message.edit', {name:''})" class="hit-html-a hit-text-center">
              <hit_stars :stars="i" :notEmpty="true" style="font-size:1.5em;"/>
              <br />
              {{ $tc("message.targetPage", 1) }}: {{ i }} {{ $tc("message.star", i) }}
            </a>
          </li>

        </ul>
        <div class="hit-panel hit-panel-default" >
          <div class="hit-panel-body" spellcheck="false">

                <h3 class="hit-html-h3" v-if="get_boards()[board]">{{ get_boards()[board].name }}</h3>
                <h4 class="hit-html-h4">{{ $tc("message.targetPage", 1) }}: {{ edit }} {{ $tc("message.star", edit) }}</h4>

                <transition name="fade" >
                  <div v-bind:key="board+edit">
                    <ckeditor id="imprint" :editor="editor" v-model="text" :config="editorConfig" ></ckeditor>
                  </div>
                </transition>

          </div>

        </div>

  </div>

</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import '@ckeditor/ckeditor5-build-classic/build/translations/de'

export default {

  data: function () {
    return {
      edit: 1,
      board: this.$route.params.id,
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [ 'heading', '|', 'bold', 'italic', '|', 'link', '|', 'bulletedList', 'numberedList' ],
        language: 'de'

      },
      text: this.get_text()
    }
  },
  methods: {

    get_text () {
      if (typeof this.edit === 'undefined') { this.edit = 1 }

      var r = this.$nl2br(this.$t('demo.targetText', {star: this.edit}))

      try {
        if (typeof this.$store.getters.target_pages[this.board][this.edit] !== 'undefined') { r = this.$store.getters.target_pages[this.board][this.edit] }
      } catch (err) { };

      return r
    },
    change_edit (i) {
      this.edit = i
      this.text = this.get_text()
    },
    check_class (i) {
      if (i == this.edit) { return 'hit-active' }
    },
    get_boards () {
      return Object.assign({0: {name: '*** ' + this.$t('message.default', {name: this.$tc('message.settings', 1)}) + ' ***'}}, this.$store.getters.boards_by_id)
    },

    set_save (val) {
      var send = {

        stars: this.edit,
        text: val,
        board: this.board,
        user: this.$store.getters.user.md5_id
      }

      this.$store.dispatch('set_change_target_page', send)
    }

  },

  watch: {
    'text': function (val) { this.set_save(val) },
    'board': function (val) { this.$router.push({name: this.$route.name, params: Object.assign(this.$route.params, {id: val})}); this.text = this.get_text() }
  },

  mounted () {
    this.$store.commit('get_session_user')

    if (this.$store.getters.user) {
      this.$store.dispatch('get_user_boards')
      this.$store.dispatch('get_all_votes')
      this.$store.dispatch('get_all_target_pages', this.$store.getters.user.md5_id)
    }
  }

}

</script>
